import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { orderDetail } from "../../../redux/actions/orderActions";
import CurrentOrdersViewTable from "../../tables/currentOrdersViewTable";
import "../modal.css";
// import { CSVLink, CSVDownload } from "react-csv";
import PlaceOrderTableModal from "../placeOrderTableModal";
import html2pdf from "html2pdf.js";
import LoadingSpinnerTable from "../../utilites/loader";
import CurrentOrdersPdfView from "./currentOrdersPdfView";

const CurrentOrdersViewModal = ({ ordersViewShow, showClose, id }) => {

  console.log(id, "ididid");
  const dispatch = useDispatch();
  const [orderDetailData, setOrderDetailData] = useState(null);
  const [csvData, setCSVData] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pdfView, setPdfView] = useState(false);

  useEffect(() => {
    console.log(ordersViewShow);
    if (ordersViewShow == true) {
      dispatch(orderDetail(id, onSuccess, onError));
      setLoading(true);
    }
  }, [ordersViewShow]);

  const onSuccess = (data) => {
    setLoading(false);
    setOrderDetailData(data.data.data);
    let newData = data.data.data.orderProducts.map((ex) => ({
      "Product Name": ex.product?.product_name,
      Division: ex?.vendorDivision?.name,
      Qnatity: ex?.quantity,
      "Free Quantity": ex?.offer_qty,
      Price: ex?.price,
    }));
    console.log(newData);
    setCSVData(newData);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const data = [
    {
      title: "Order ID",
      content: orderDetailData?.order_id,
    },
    {
      title: "Company Name",
      content: orderDetailData?.vendor?.name,
    },
    {
      title: "Division",
      content: orderDetailData?.vendorDivision?.name,
    },
    {
      title: "Value Of Order",
      content: `₹ ${orderDetailData?.total}`,
    },
    {
      title: "Reimbursement Status",
      content: "---",
    },
    {
      title: "Doctor Name",
      content: orderDetailData?.doctor?.name ?? "---",
    },
    {
      title: "Pharmacy Name",
      content: orderDetailData?.pharmacy_id
        ? orderDetailData?.pharmacy?.pharmacy_name
        : orderDetailData?.doctor?.pharmacy_type == "attach"
          ? orderDetailData?.doctor?.doctorAttachPharmacy?.pharmacy?.pharmacy_name
          : orderDetailData?.doctor?.pharmacy_type == "self"
            ? orderDetailData?.doctor?.doctorSelfPharmacy?.pharmacy_name
            : orderDetailData?.doctor?.pharmacy_type == "dispensing" &&
            "Dispensing",
    },
    {
      title: "Mobile Number",
      content: orderDetailData?.doctor?.mobile ?? orderDetailData?.pharmacy?.mobile,
    },
  ];

  const data2 = [
    {
      title: "Alternate Mobile Number",
      content: orderDetailData?.doctor?.alternate_mobile ?? orderDetailData?.pharmacy?.alternate_mobile,
    },
    {
      title: "Email Address",
      content: orderDetailData?.doctor?.email ?? orderDetailData?.pharmacy?.email,
    },
    {
      title: "Address",
      content: orderDetailData?.doctor ? `${orderDetailData?.doctor?.address?.address_one}, ${orderDetailData?.doctor?.address?.address_two}, ${orderDetailData?.doctor?.address?.address_three}` :
        `${orderDetailData?.pharmacy?.address?.address_one}, ${orderDetailData?.pharmacy?.address?.address_two}, ${orderDetailData?.pharmacy?.address?.address_three}`,
    },
    {
      title: "Landmark",
      content: orderDetailData?.doctor?.address?.landmark ?? orderDetailData?.pharmacy?.address?.landmark,
    },
    {
      title: "Concerned FF Name",
      content: orderDetailData?.orderHeirarchy?.fieldForceUser?.name,
    },
    {
      title: "Concerned FF Mobile Number",
      content: orderDetailData?.orderHeirarchy?.fieldForceUser?.mobile,
    },
    {
      title: "Concerned CFA Name",
      content: orderDetailData?.concernedCfa?.cfa_name,
    },
    {
      title: "Concerned CFA Mobile Number",
      content: orderDetailData?.concernedCfa?.mobile,
    },
  ];
  const outerComponentRef = useRef(null);

  const exportToPdf = () => {
    const toRender = document.getElementById("toRender");
    const options = {
      margin: [30, 10],
      filename: "orders.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(toRender).save();
  };

  return (
    <>
      {/* <div ref={outerComponentRef} style={{position:"absolute" , top:"-9999px"}}>
        <CurrentOrdersPdfView />
      </div> */}

      <Modal
        centered
        show={ordersViewShow}
        onHide={showClose}
        id={id}
        dialogClassName="current-orders-view-container col-10 mx-auto px-3"
      >
        <ModalHeader>
          <div className=" d-flex justify-content-between w-100 ">
            <div>
              <span className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-0">
                {orderDetailData?.order_id} - View
              </span>
            </div>
            <div className="d-flex justify-content-end  gap-2">
              {/* <button
              className="modal-place-btn text-white px-3 py-2 fs_12"
              type="button"
              onClick={() => setShow(true)}
            >
              Place Order to CFA
            </button> */}
              <div className="mt-1">
                {/* <CSVLink
                className="modal-submit-btn text-white px-4 py-2 fs_12"
                // type="button"
                data={csvData}
                target="_blank"
              >
                Print
              </CSVLink> */}
                <button
                  type="button"
                  onClick={() => {
                    showClose();
                    setPdfView(true);
                  }}
                  className="modal-submit-btn text-white px-4 py-2 fs_12"
                >
                  print
                </button>
              </div>
              <button
                className="modal-close-btn px-3 py-1 fs_12 "
                onClick={() => showClose()}
              >
                <span className="fw_700">close</span>
              </button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="w-100 h-100" id="toRender">
          {loading == true ? (
            <LoadingSpinnerTable />
          ) : (
            <div className="w-100 h-100">
              <div className="mx-2">
                <div className="d-flex ">
                  <div className="col-6 col-lg-5">
                    {data.map((items, index) => (
                      <div className="d-flex gap-" key={index}>
                        <div className="col-6 col-sm-5">
                          <span className="color_b0b3c7 fs_12">
                            {items.title}
                          </span>
                        </div>
                        <span className="fs_12 ms-3">{items.content}</span>
                      </div>
                    ))}
                  </div>
                  <div className="col-6">
                    {data2.map((items, index) => (
                      <div className="d-flex gap-" key={index}>
                        <div className="col-6 col-sm-5">
                          <span className="color_b0b3c7 fs_12">
                            {items.title}
                          </span>
                        </div>
                        <span className="fs_12 ms-3 col-6">
                          {items.content}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-3">
                  <p className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-2 label-text">
                    Order Details - {orderDetailData?.order_id}
                  </p>
                  <div className="mt-3">
                    <CurrentOrdersViewTable
                      orderProducts={orderDetailData?.orderProducts}
                      total={orderDetailData?.total}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </ModalBody>

        <PlaceOrderTableModal
          show={show}
          handleClose={() => setShow(false)}
          orderProducts={orderDetailData?.orderProducts}
        />
      </Modal>
      <CurrentOrdersPdfView
        orderDetailData={orderDetailData}
        id={id}
        show={pdfView}
        handleClose={() => setPdfView(false)}
      />
    </>

  );
};

export default CurrentOrdersViewModal;
